export const contractStatisticsPath = {
  COMMON: '',
  COMPLEX: '/complex'
};
